module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_vm._t("heading-left")], 2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_vm._t("heading-right")], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body",
    slot: "body"
  }, [_vm._t("body")], 2), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  }, [_vm._t("footer")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/abuild/rpmbuild/BUILD/Portus-v2.3/~/vue-loader/lib/template-compiler?{"id":"data-v-69be28a4"}!/home/abuild/rpmbuild/BUILD/Portus-v2.3/~/vue-loader/lib/selector.js?type=template&index=0!./shared/components/panel.vue
// module id = 362
// module chunks = 0